import SmallCabNoFreeBoxModal from './SmallCabNoFreeBoxModal';

export default SmallCabNoFreeBoxModal;
